import fpApiUtil from "./fp-api-util";

const ITEM = "factoryplan/master/item/items";
const ITEM_GROUP = "factoryplan/master/item/itemgroups";
const INVENTORY = "factoryplan/master/item/inventories";

const getItems = (params) => fpApiUtil.postParams(ITEM, params);
const upsertItems = (changes) => fpApiUtil.postChanges(`${ITEM}/save`, changes);
const removeItems = (changes) => fpApiUtil.postChanges(`${ITEM}/delete`, changes);

const getItemGroups = (params) => fpApiUtil.postParams(ITEM_GROUP, params);
const saveItemGroups = (changes) => fpApiUtil.postChanges(`${ITEM_GROUP}/save`, changes);
const removeItemGroups = (changes) => fpApiUtil.postChanges(`${ITEM_GROUP}/delete`, changes);

const getInventories = (params) => fpApiUtil.postParams(INVENTORY, params);
const upsertInventories = (changes) => fpApiUtil.postChanges(`${INVENTORY}/save`, changes);
const removeInventories = (changes) => fpApiUtil.postChanges(`${INVENTORY}/delete`, changes);

const fpItemService = {
  getItems, upsertItems, removeItems,
  getItemGroups, saveItemGroups, removeItemGroups,
  getInventories, upsertInventories, removeInventories,
};
export default fpItemService;
